/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/gmail" */ '@atlassian/logo-third-party/gmail'
		).then((m) => m.GmailIcon),
	{ moduleId: '@atlassian/logo-third-party/gmail' },
);

const LazyGmailIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-gmail" */ './utils').then((m) => m.GmailIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/gmail/icon' },
);

const LazyGmailSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-gmail-search-result" */ './utils').then(
			(m) => m.GmailSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/gmail/search-result-icon' },
);

const LazyGmailIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-gmail-borderless" */ './utils').then(
			(m) => m.GmailIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/gmail/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GmailIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyGmailIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const GmailSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyGmailSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);

export const GmailIconBorderless: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyGmailIconBorderlessComponent />
		</Suspense>
	),
	OfficialIcon,
	'xxsmall',
);
